module.exports = __webpack_public_path__ + "static/media/yes_bank_Logo.f1846233.png";